import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import { Redirect } from 'react-router';
import jwt from 'jsonwebtoken';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  deleteDashboard,
  fetchDashboardById,
  updateDashboard,
} from '../../actions/dashboard';
import { USER_ROLE } from '../../constants';
import s from './Dashboard.module.scss';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import EditorArea from './EditorArea';
import axios from "axios";

class DashboardDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currUser: {},
      redirect: false,
      modalToggleUpdateDashboard: false,
      dashboardContent: { title: '', body: '', highlight: false },
      dashboardDetail: { title: '', body: '', highlight: false, code: '', codeDN: '', codeHN: '', location: 'HCM' },
      isOpenToast: false,
      allGroups: [],
      isPseudoFullscreen: false,
    };
    this.onUpdateDashboard = this.onUpdateDashboard.bind(this);
    this.onChangeUpdateDashboard = this.onChangeUpdateDashboard.bind(this);
    this.toggleUpdateDashboard = this.toggleUpdateDashboard.bind(this);
    this.changeLocation = this.changeLocation.bind(this);
    this.getAllGroups = this.getAllGroups.bind(this);
  }

  toggleUpdateDashboard() {
    this.setState({
      modalToggleUpdateDashboard: !this.state.modalToggleUpdateDashboard,
    });
  }

  async onUpdateDashboard(e) {
    e.preventDefault();
    try {
      let { pricingId } = this.props.match.params;
      await axios.post(`/update-pricing/${pricingId}`, this.state.dashboardContent)
      this.setState((prevState) => ({ modalEditToggle: !prevState.modalEditToggle }));
      e.preventDefault();
    } catch (err) {
      toast.error('Đã có lỗi xảy ra');
      return
    }
    this.toggleUpdateDashboard();
    this.setState({isOpenToast: true})
  }

  onChangeUpdateDashboard(e, name) {
    const fieldName = name || (e && e.target ? e.target.name : null);
    if (!fieldName) return;

    let fieldValue;
    if (e && e.target) {
      fieldValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    } else {
      fieldValue = e;
    }

    this.setState({
      dashboardContent: {
        ...this.state.dashboardContent,
        [fieldName]: fieldValue,
      },
    });
  }

  changeLocation(e) {
    const { name, value } = e.target;
    let newDashboard = this.state.dashboardContent
    newDashboard[name] = value
    this.setState({ dashboardContent: newDashboard })
  }

  updateDashboard(item) {
    this.setState({
      dashboardContent: item,
      modalToggleUpdateDashboard: !this.state.modalToggleUpdateDashboard,
    });
  }

  deleteNotification(id) {
    const self = this
    confirmAlert({
      title: 'Xác nhận Xoá',
      message: 'Bạn có chắc muốn xoá thông báo này?',
      buttons: [
        {
          label: 'Có',
          onClick: async () => {
            await axios.get(`/delete-pricing/${id}`)
            this.setState({ redirect: true });
          },
        },
        { label: 'Không', onClick: () => {} },
      ],
    });
  }

  async componentDidMount() {
    let token = localStorage.getItem('id_token');
    let currUser = jwt.decode(token);
    this.setState({ currUser: currUser });
    await this.getPricingById();
    await this.getAllGroups();
  }

  async getAllGroups() {
    try {
      const res = await axios.get('/get-all-pricing?size=all');
      if (res && res.data && res.data.list) {
        this.setState({ allGroups: res.data.list.filter(item => item.type === 'group') });
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getPricingById(params = {}) {
    try {
      let { pricingId } = this.props.match.params;

      const res = await axios.post(`/get-pricing/${pricingId}`, )
      if (res && res.data) {
        console.log(res.data)
        this.setState({dashboardDetail: res.data})
      }
    } catch (e) {
      console.error(e)
    }
  }

  handleFullscreen() {
    const iframe = this.iframeRef;
    if (!iframe) return;

    const useNative = !!(iframe.requestFullscreen || iframe.webkitRequestFullscreen || iframe.msRequestFullscreen);
    
    // Check if it's iOS (iPhone/iPad/iPod)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (useNative && !isIOS) {
      if (iframe.requestFullscreen) {
        iframe.requestFullscreen();
      } else if (iframe.webkitRequestFullscreen) { /* Safari */
        iframe.webkitRequestFullscreen();
      } else if (iframe.msRequestFullscreen) { /* IE11 */
        iframe.msRequestFullscreen();
      }
    } else {
      // Fallback for iOS or devices without native Fullscreen API
      this.setState({ isPseudoFullscreen: true });
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    }
  }

  exitPseudoFullscreen() {
    this.setState({ isPseudoFullscreen: false });
    document.body.style.overflow = ''; // Restore scrolling
  }

  buildTree(items) {
    const map = {};
    const tree = [];
    items.forEach(item => {
      map[item.id] = { ...item, children: [] };
    });
    items.forEach(item => {
      if (item.parentId && map[item.parentId]) {
        map[item.parentId].children.push(map[item.id]);
      } else {
        tree.push(map[item.id]);
      }
    });
    return tree;
  }

  renderTreeOptions(nodes, level = 0) {
    let options = [];
    nodes.forEach(node => {
      if (node.type === 'group') {
        options.push(
          <option key={node.id} value={node.id}>
            {'\u00A0'.repeat(level * 4)}{level > 0 ? '↳ ' : ''}{node.title}
          </option>
        );
        if (node.children && node.children.length > 0) {
          options = options.concat(this.renderTreeOptions(node.children, level + 1));
        }
      }
    });
    return options;
  }

  render() {
    const { dashboardDetail, dashboardContent, allGroups = [] } = this.state;
    const { redirect } = this.state;
    
    // Default location from content or detail, otherwise 'HCM'
    const curLocation = dashboardContent?.location || dashboardDetail?.location || 'HCM';
    const groups = allGroups.filter(g => g.location === curLocation);

    if (this.props.message && this.state.isOpenToast) {
      toast.error(this.props.message);
      this.setState({isOpenToast: false})
    }
    
    if (redirect) {
      return <Redirect to='/app/pricing' />;
    }

    return (
      <div className={s.root}>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

        {/* Breadcrumbs */}
        <div className={s.breadcrumbContainer}>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/app/pricing">Bảng giá</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Nội dung chi tiết</li>
            </ol>
          </nav>
        </div>

        {/* Detail Header */}
        <div className={s.detailHeader}>
          <div className={s.backLink} onClick={() => this.props.history.goBack()} style={{ cursor: 'pointer' }}>
            <i className="fa fa-arrow-left" /> Quay lại
          </div>
          <h1>{dashboardDetail?.title || 'Đang tải...'}</h1>
          <div className={s.badge}>
            <i className="fa fa-map-marker mr-1" />
            Khu vực: {dashboardDetail?.location === 'HCM' ? 'Hồ Chí Minh' : dashboardDetail?.location === 'HN' ? 'Hà Nội' : dashboardDetail?.location === 'ĐN' ? 'Đà Nẵng' : 'Tham khảo'}
          </div>
        </div>

        <Row>
          <Col md={12}>
            {dashboardDetail && (
              <div className={cx(s.contentCard, { 'border-danger': dashboardDetail?.highlight })}>
                <div className={s.contentTitle}>Nội dung chi tiết</div>
                <div className="mb-4">
                  {ReactHtmlParser(dashboardDetail?.body)}
                </div>
                
                {dashboardDetail?.code && (
                  <div className={cx("mt-4 pt-4 border-top", s.iframeSection, { [s.pseudoFullscreen]: this.state.isPseudoFullscreen })}>
                    <div className={s.iframeHeader}>
                      {this.state.isPseudoFullscreen ? (
                        <button 
                          className={cx(s.btnFullscreen, s.btnCloseFullscreen)}
                          onClick={() => this.exitPseudoFullscreen()}
                        >
                          <i className="fa fa-times mr-1" /> Đóng toàn màn hình
                        </button>
                      ) : (
                        <button 
                          className={s.btnFullscreen}
                          onClick={() => this.handleFullscreen()}
                          title="Xem toàn màn hình"
                        >
                          <i className="fa fa-expand mr-1" /> Toàn màn hình
                        </button>
                      )}
                    </div>
                    <div className={s.iframeWrapper}>
                      <iframe 
                        ref={(ref) => this.iframeRef = ref}
                        src={dashboardDetail?.code} 
                        frameBorder="0"
                        className={s.embeddedIframe}
                        title="Pricing Content"
                      />
                    </div>
                  </div>
                )}

                {this.state.currUser.email !== 'pricingtinphatexp@gmail.com' && (this.state.currUser.role === USER_ROLE.ADMIN || this.state.currUser.role === USER_ROLE.DOCUMENT) && (
                  <div className={s.actionFooter}>
                    <button
                      className={cx(s.btnPremium, s.btnPremiumGroup)}
                      onClick={() => this.updateDashboard(dashboardDetail)}
                    >
                      <i className='fa fa-pencil' /> Chỉnh sửa
                    </button>
                    <button
                      className={cx(s.btnPremium)}
                      style={{ background: '#fee2e2', color: '#ef4444' }}
                      onClick={() => this.deleteNotification(dashboardDetail?.id)}
                    >
                      <i className='fa fa-trash-o' /> Xoá bảng giá
                    </button>
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>

        {/* Update content of dashboard */}
        <Modal
          isOpen={this.state.modalToggleUpdateDashboard}
          toggle={this.toggleUpdateDashboard}
          size="lg"
        >
          <ModalHeader>Chỉnh sửa bảng giá</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for='title'>Tiêu đề</Label>
              <Input
                value={this.state.dashboardContent.title}
                name='title'
                id='title'
                placeholder='Nhập tiêu đề...'
                onChange={(e) => this.onChangeUpdateDashboard(e)}
              />
            </FormGroup>
            <FormGroup>
              <Label for='parentId'>Thuộc nhóm</Label>
              <Input
                type="select"
                name="parentId"
                id="parentId"
                value={this.state.dashboardContent.parentId || ''}
                onChange={(e) => this.onChangeUpdateDashboard(e)}
              >
                <option value="">-- Không thuộc nhóm nào (Gốc) --</option>
                {this.renderTreeOptions(this.buildTree(allGroups))}
              </Input>
            </FormGroup>
            <FormGroup style={{ minHeight: '400px' }}>
              <Label for='content'>Nội dung</Label>
              <EditorArea
                value={this.state.dashboardContent.body}
                onChange={(e) => this.onChangeUpdateDashboard(e, 'body')}
              />
            </FormGroup>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="location">Khu vực</Label>
                  <Input id="location" name="location" value={this.state.dashboardContent.location} type="select"  onChange={this.changeLocation}>
                    <option value="HCM">Hồ Chí Minh</option>
                    <option value="HN">Hà Nội</option>
                    <option value="ĐN">Đà Nẵng</option>
                    <option value="Custom">GIÁ BÁN THAM KHẢO</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="d-flex align-items-center h-100 pt-3">
                  <div className="abc-checkbox abc-checkbox-danger">
                    <Input 
                      id="highlight" 
                      name="highlight" 
                      type="checkbox" 
                      checked={this.state.dashboardContent.highlight}
                      onChange={(e) => this.onChangeUpdateDashboard({ target: { name: 'highlight', value: e.target.checked } })}
                    />
                    <Label for="highlight">Nổi bật (Chữ đỏ)</Label>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <img src={this.state.dashboardContent.code} width="100%"/>
            <FormGroup>
              <Label for='code'>Link Embed or Image URL</Label>
              <Input
                type="textarea"
                name='code'
                value={this.state.dashboardContent.code}
                placeholder="Dán link embed hoặc URL ảnh vào đây..."
                onChange={(e) => this.onChangeUpdateDashboard(e, 'code')}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
             <Button color='success' className="px-4" onClick={(e) => this.onUpdateDashboard(e)}>Lưu thay đổi</Button>
             <Button color='secondary' onClick={this.toggleUpdateDashboard}>Đóng</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
export default DashboardDetail;
